export const SANITIZE_TEXT_REGEX = /[^a-zA-Z<>&@.-\d\s:]/g
export const SANITIZE_NUMBER_REGEX = /[^0-9]/g
export const PDP_REGEX = /^([\/]).*.([\-]).([0-9]{2,}).*$/gm
export const URL_REPLACE_REGEX = /\s&\s|\s/g
export const MEMBERSHIP_VALID_MAIL_ERROR_REGEX = /\S+@\S+\.\S+/
export const MEMBERSHIP_CODE_ERROR_REGEX = /@kohler.com\s*$/
export const FULL_NAME_REGEX = /^[a-zA-Z]+ [a-zA-Z]+$/
export const PURE_TEXT_REGEX = /<[^>]*>/g
export const SPECIAL_CHAR_REGEX = /[^a-zA-Zd0-9 ]/g
export const NUMBER_HEADING_REGEX = /^[1-6]$/
export const ALPHABET_WITH_SPACE_REGEX = /^[a-zA-Z ]*$/
export const POSTAL_CODE_US_REGEX = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/
export const POSTAL_CODE_CA_REGEX = /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/
export const POSTAL_CODE_REGEX = /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/
export const INCH_SYMBOL_REGEX = /\d$/
export const DATA_LAYER_REGEX = /&amp;/g
export const PURE_DATA_FOR_STRING_REGEX = /(\r\n|\n|\r)/gm
export const SPACE_REGEX = /\s+/g
export const FILTER_PARAM_REGEX = /[\/\\]/g
export const TEXT_AREA_LABEL_REGEX = /\*/g
export const SAVE_TO_LIST_NAME_FIELD_REGEX = /^[a-zA-Z0-9 ]*$/
export const VISUAL_NAV_IMAGEID_FOR_DATALAYER = /\/([^\/]+)\.(jpg|jpeg|png)$/i
export const UPPERCASE_REGEX = /(?=.*[A-Z])/
export const ZIP_CODE_MATCH_WHITESPACE_REGEX = /\s/g
export const ZIP_CODE_DIGIT_REGEX = /^\d+$/
export const VIDEO_ID_REGEX = /PAWEB\/|Kohler\//
export const SANITIZE_FLOAT_NUMBER_REGEX = /[^0-9.]/g
export const NAME_REGEX = /^[a-zA-Z-'.]+$/
export const IMAGEID_DATALAYER_REGEX = /PAWEB\/(\w+)_/
export const SELECT_AFTER_LAST_SLASH_REGEX = /\/[^\/]*$/
export const QUOT_REGEX = /&quot;/g
export const DOUBLE_QUOTE_REGEX = /"/g
export const UNDERSCORE_REPLACE_REGEX = /_/g
export const CAMEL_CASE_REGEX = /([a-z])([A-Z])/g
export const CAMEL_CASE_REPLACE_PATTERN = "$1 $2"
export const FACET_FORMAT_REGEX = /(^facet:')|('\s*$)/g
export const THREEKIT_SWATCH_PREFIX_REGEX = /^swatch_/
export const SANITIZE_TAG_OR_UNDEFINED_REGEX = /^[a-z][a-z0-9:-]*$/i
export const HTML_STRING_REGEX_OPT1 = /<([a-z][\w:-]*)(\s[^>]*)?>[\s\S]*<\/\1>/i
export const HTML_STRING_REGEX_OPT2 = /<([a-z][\w:-]*)(\s[^>]*)?\/>/i
export const VISUAL_NAV_SCENE7_REGEX = /Visual-Nav-Filter-([a-z]{3})(\d+)_rgb/i
export const FIRST_LETTER_REGEX = /\b\w/g
export const PIPE_NOT_PRECEDED_BY_BACKSLASH_REGEX = /(?<!\\)\|/
export const BACKSLASH_REGEX = /\\/g
export const MATCH_DIGIT_FOLLOWED_BY_INCH_SYMBOL_REGEX = /(\d+)"/g
export const NON_DIGIT_REGEX = /\D/g
export const PHONE_DISPLAY_REGEX = /(\d{0,3})(\d{0,3})(\d{0,4})/
export const SPACE_BEFORE_COMMA_REGEX = /\s+,/g
export const ABSOLUTE_URL_REGEX = /^https?:\/\//i
export const KCOM_DOMAIN_REGEX = /(^|\.)kohler\.com$/i
export const IS_IMAGE_PREFIX_REGEX = /\/is\/image\/[^/]+\//
export const PO_BOX_REGEX = /po\s*box/i
export const APO_FPO_DPO_REGEX = /\b(?:APO|FPO|DPO)\b/i
export const US_TERRITORY_REGEX = /\bU\.?S\.?\s*territor(?:y|ies)\b/i
export const CA_POSTAL_SANITIZE_REGEX = /[^A-Z0-9]/g
export const LEGACY_GBH_SQ_TEMPLATE_SUFFIX_REGEX = /\/GBH_SQTemplate\/?$/i
export const LOCAL_BLOCKED_WDP_SCRIPT_SRC_REGEX =
  /\/iov\/wdp\/.*\/static_wdp\.js(\?|$)/i
export const LOCAL_BLOCKED_INIT_SCRIPT_SRC_REGEX =
  /\/[a-z0-9]{6,}\/init\.js(\?|$)/i

export const NUMERIC_REGEX = /^\d+$/
export const VALID_GLOBAL_CONFIG_PATH_REGEX =
  /^(?!.*[\{\}#%])(?!(.*https?:\/\/|.*www\.|.*\.com))[a-zA-Z0-9\/:._=?-]+$/

// Backward compatible aliases.
export const NUMERIC_REGX = NUMERIC_REGEX
export const VALID_GLOBA_CONFIG_PATHS = VALID_GLOBAL_CONFIG_PATH_REGEX

// Stale build asset recovery - detects chunk load failures during deployments
export const STALE_BUILD_ERROR_PATTERN = /loading (CSS )?chunk/i
